/* ======================================================================== */
/* 14. header */
/* ======================================================================== */
var Header = function () {

	var
		self = this,
		$burger = $('.js-burger'),
		$overlay = $('.header__wrapper-overlay-menu'),
		$menuLinks = $('.overlay-menu > li > a .overlay-menu__item-wrapper'),
		$overlayLinks = $('.overlay-menu > li a'),
		$submenu = $('.overlay-sub-menu'),
		$submenuButton = $('.js-submenu-back'),
		$submenuLinks = $submenu.find('> li > a .overlay-menu__item-wrapper');

	stickHeader();
	setOverlayMenu();

	if (window.stickyScene) {

		/**
		 * Use debounce from lodash if possible
		 * to improve performance
		 */
		if (typeof _ === 'function') {
			$(window).on('resize', _.debounce(function () {
				resetSticky();
			}, 200));
		} else {
			$(window).on('resize', function () {
				resetSticky();
			});
		}

	}

	this.enableSticky = function (value) {

		stickHeader();

		if (value != true && window.stickyScene) {
			window.stickyScene = window.stickyScene.destroy(true);
		}

	}

	function resetSticky() {
		if (window.stickyScene) {
			window.stickyScene = window.stickyScene.destroy(true);
			stickHeader();
		}
	}

	function stickHeader() {

		var $header = $('.js-header-sticky');
		var admin_bar_mobile = false;

		if (!$header.length) {
			return false;
		}

		if (Modernizr.mq('(max-width: 600px)') && $('body').hasClass('admin-bar')) {
			admin_bar_mobile = true;
		}

		if (!window.stickyScene) {

			window.stickyScene = new $.ScrollMagic.Scene({
					offset: admin_bar_mobile ? '46px' : '1px',
				})
				.setPin($header, {
					pushFollowers: false
				})
				.setClassToggle($header, 'header_sticky')
				.addTo(SMController);

		}

	}

	function setOverlayMenu() {

		TweenMax.set($overlay, {
			autoAlpha: 1
		});

		TweenMax.set([$overlay, $menuLinks, $submenuLinks], {
			y: '100%'
		});

		TweenMax.set([$submenu, $submenuButton], {
			autoAlpha: 0,
			y: '10px'
		});

	}

	this.closeOverlayMenu = function () {

		var tl = new TimelineMax();

		tl.timeScale(2);

		tl
			.set($overlay, {
				className: '+=in-transition'
			})
			.to([$menuLinks, $submenuLinks], 0.6, {
				y: '-100%',
				ease: Power4.easeIn
			})
			.to($submenuButton, 0.6, {
				y: '-10px',
				autoAlpha: 0
			})
			.to($overlay, 1, {
				y: '-100%',
				ease: Expo.easeInOut
			})
			.set($overlay, {
				className: '-=in-transition'
			})
			.add(function () {
				setOverlayMenu();
			});

	};

	this.openOverlayMenu = function () {

		var tl = new TimelineMax();

		tl
			.set($overlay, {
				className: '+=in-transition'
			})
			.to($overlay, 1, {
				y: '0%',
				ease: Expo.easeInOut,
			})
			.staggerTo($menuLinks, 0.6, {
				y: '0%',
				ease: Power4.easeOut,
			}, .05, '-=0.3')
			.set($overlay, {
				className: '-=in-transition'
			});

	};

	$overlayLinks.on('click', function (e) {

		var $el = $(this);

		if (checkIsAnchor($el) == true) {
			$burger.removeClass('burger_opened');
			self.closeOverlayMenu();
		}

	});

}
